import useEventStore from '../stores/eventStore';
import useQueueStore from '../stores/queueStore';
import { useRoleStore } from '../stores/roleStore';
import usePlayerStore from '../stores/playerStore';
import useReactionStore from '../stores/reactionStore';
import { clearSessionEventId } from '../services/sessionRef';

export const initializeStores = () => {
  // Reset event-scoped state. Keep the authenticated uid.
  useEventStore.getState().setPresenceByUid({});
  useEventStore.getState().setEventData(null);
  useQueueStore.getState().clearQueue();
  useRoleStore.getState().resetRole();
  usePlayerStore.getState().resetPlayer();
  useReactionStore.getState().reset();
};

export const cleanupStores = () => {
  useEventStore.getState().setPresenceByUid({});
  useEventStore.getState().setEventData(null);
  useQueueStore.getState().clearQueue();
  useRoleStore.getState().resetRole();
  usePlayerStore.getState().resetPlayer();
  useReactionStore.getState().reset();
  clearSessionEventId();
};